// src/store/useUiStore.ts

import { create } from 'zustand';

interface UiState {
  spiritPickerSlot: number | null;
  skillPickerSlot: number | null;
  statEditorSlot: number | null;
  natureEditorSlot: number | null;

  openSpiritPicker: (slot: number) => void;
  openSkillPicker: (slot: number) => void;
  openStatEditor: (slot: number) => void;
  openNatureEditor: (slot: number) => void;

  closeSpiritPicker: () => void;
  closeSkillPicker: () => void;
  closeStatEditor: () => void;
  closeNatureEditor: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  spiritPickerSlot: null,
  skillPickerSlot: null,
  statEditorSlot: null,
  natureEditorSlot: null,

  openSpiritPicker: (slot) => set({ spiritPickerSlot: slot }),
  openSkillPicker: (slot) => set({ skillPickerSlot: slot }),
  openStatEditor: (slot) => set({ statEditorSlot: slot }),
  openNatureEditor: (slot) => set({ natureEditorSlot: slot }),

  closeSpiritPicker: () => set({ spiritPickerSlot: null }),
  closeSkillPicker: () => set({ skillPickerSlot: null }),
  closeStatEditor: () => set({ statEditorSlot: null }),
  closeNatureEditor: () => set({ natureEditorSlot: null }),
}));